export default __webpack_public_path__ + "static/media/DJI_0940.MP4.00_01_47_08.Still009.7fbdcd71.jpg";